import { useState, useRef } from "react";
import "animate.css";

import {
	Box,
	Typography,
	Container,
	useMediaQuery,
	useTheme,
	TextField,
} from "@mui/material";

import LoadingButton from "@mui/lab/LoadingButton";
import AddIngredientRow from "./Add Recipe/addIngredient";
import EmojiPicker from "./Add Recipe/emojiPicker";
import AddTags from "./Add Recipe/addTags";
import TransitionAlerts from "./transitionAlert";

function AddRecipe() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const boxRef = useRef(null);

	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("");
	const [externalLink, setExternalLink] = useState("");
	const [ingredients, setIngredients] = useState([
		{ ingredient: "", quantity: "", type: "st" },
	]);
	//const [, setNumberOfRows] = useState(1);
	const [pickedEmoji, setPickedEmoji] = useState();
	const [selectedTags, setSelectedTags] = useState([]);
	const [, setAlertText] = useState("");
	const [openAlert, setOpenAlert] = useState(false);

	function handleOpenAlert() {
		setOpenAlert(true);
	}
	function handleCloseAlert() {
		setOpenAlert(false);
	}
	function addTag(newTag) {
		setSelectedTags((prevTags) => [...prevTags, newTag]);
	}
	function removeTag(tagToRemove) {
		setSelectedTags((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
	}
	const addIngredientRow = () => {
		setIngredients([
			...ingredients,
			{ ingredient: "", quantity: "", type: "st" },
		]);
	};

	const updateIngredient = (index, field, value) => {
		const newIngredients = [...ingredients];
		newIngredients[index][field] = value;
		setIngredients(newIngredients);
	};
	const createRecipe = async (
		title,
		tags,
		emoji,
		externalLink = "",
		ingredients,
		userEmail = ""
	) => {
		setLoading(true);
		userEmail = localStorage.getItem("userEmail");
		const payload = {
			title,
			tags,
			emoji,
			externalLink,
			ingredients,
			userEmail,
		};

		try {
			const res = await fetch(
				"https://us-central1-mealplanner-f6b88.cloudfunctions.net/api/create-recipe",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(payload),
				}
			);
			const data = await res.json();
			setAlertText(data.title);
		} catch (error) {
			setAlertText("Failed to create recipe");
		} finally {
			setLoading(false);
			resetForm();
			handleOpenAlert();
		}
	};

	const resetForm = () => {
		setIngredients([{ ingredient: "", quantity: "", type: "st" }]);
		setTitle("");
		setExternalLink("");
		setPickedEmoji("");
		setSelectedTags([]);
		if (boxRef.current) {
			boxRef.current.scrollTo({ top: 0, behavior: "smooth" });
		}
	};
	return (
		<div
			id="AddRecipeTop "
			className="Landing animate__animated animate__fadeIn animate__slow"
		>
			<Container
				sx={{
					display: "flex",
					flexDirection: "column", // stack children vertically
					justifyContent: "center", // vertical centering
					alignItems: "center", // horizontal centering
					height: "100vh", // full viewport height (or any height you want)
					textAlign: "center",
				}}
			>
				<Box
					className="Landing-heading"
					sx={{
						textAlign: { xs: "center", md: "center" },
						paddingTop: { xs: 10 },
						paddingBottom: { xs: 2 },
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						gap: 0.5, // <-- controls spacing between children
					}}
				>
					<Typography
						variant="h2"
						className="colorText"
						sx={{
							fontSize: { xs: "2rem", md: "3rem" },
							fontWeight: "bold",
							color: "#333",
							marginBottom: 0, // Remove bottom margin
						}}
					>
						Add <span className={isMobile ? "colorText" : "colorText"}>Recipe</span>
					</Typography>
					<Typography sx={{ marginTop: 0 }} variant="overline">
						Add a new meal to the database
					</Typography>
					<TransitionAlerts
						openAlert={openAlert}
						text={"The recipe was successfully added to the database!"}
						onClose={handleCloseAlert}
					/>
				</Box>
				<Box
					ref={boxRef}
					sx={{
						paddingTop: 3,
						display: "flex",
						flexDirection: "column",
						overflow: "scroll",
						padding: isMobile ? 1 : 2,
					}}
					maxWidth={isMobile ? 600 : 500}
				>
					<Typography textAlign="start" variant="overline">
						Add the name of the dish
					</Typography>
					<TextField
						//maxWidth="100%"
						value={title}
						onChange={(e) => {
							setTitle(e.target.value);
							//console.log(title);
						}}
						label="Title"
					>
						{title}
					</TextField>
					<Typography textAlign="start" variant="overline">
						Add a link to the recipe if you have one
					</Typography>
					<TextField
						//maxWidth="100%"
						value={externalLink}
						onChange={(e) => {
							setExternalLink(e.target.value);
							//console.log(title);
						}}
						label="External Link"
					>
						{externalLink}
					</TextField>
					<AddTags
						selectedTags={selectedTags}
						addTag={addTag}
						removeTag={removeTag}
					/>
					<EmojiPicker pickedEmoji={pickedEmoji} setPickedEmoji={setPickedEmoji} />
					<Typography paddingTop={3} textAlign="start" variant="overline">
						Enter the main ingredients (optional)
					</Typography>

					<AddIngredientRow
						ingredients={ingredients}
						updateIngredient={updateIngredient}
						addIngredientRow={addIngredientRow}
					/>
					<LoadingButton
						sx={{ marginTop: 3, marginBottom: 6 }}
						onClick={() => {
							createRecipe(
								title,
								selectedTags,
								pickedEmoji,
								externalLink,
								ingredients
							);
						}}
						loading={loading}
						size="large"
						variant="contained"
					>
						Add Recipe
					</LoadingButton>
				</Box>

				<Box sx={{ p: 2 }} />
			</Container>
		</div>
	);
}
export default AddRecipe;
